module.exports = __webpack_public_path__ + "media/images/email_templates/newsletter_thumbnail-c6c8d9a80da50b8311422c15203bf6fe.png";